function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null,
/*#__PURE__*/
React.createElement("style", null, ".a{fill:none;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("rect", {
  className: "a",
  width: 20,
  height: 20
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M18.617,13.75,11,9.941v-1.6A3.493,3.493,0,1,0,6.5,5a1,1,0,0,0,2,0A1.5,1.5,0,1,1,10,6.5a1,1,0,0,0-1,1V9.941L1.383,13.75A2.487,2.487,0,0,0,0,15.987V17a1,1,0,0,0,1,1H19a1,1,0,0,0,1-1V15.987A2.487,2.487,0,0,0,18.617,13.75ZM18,16H2v-.013a.487.487,0,0,1,.277-.449L10,11.677l7.722,3.861a.486.486,0,0,1,.278.449Z"
});

var SvgStyleSelected = function SvgStyleSelected(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 20,
      height: 20,
      viewBox: "0 0 20 20",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2, _ref3, _ref4)
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgStyleSelected, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/StyleSelected.018026f6.svg";
export { ForwardRef as ReactComponent };